export default function themeStoragre(theme = 'Get') {
    if(theme === 'Get') {
        let result = window.localStorage.getItem('theme')
        return  (result != null ? result : 'light');
    }
    window.localStorage.setItem('theme',theme);
}
